export function createOrder(product, remainder, downPaymentDuration) {
  return {
    products: [product.id],
    mainProduct: product,
    remainder: remainder,
    downPaymentDuration: downPaymentDuration,
    monthlySalaryDeduction: remainder / downPaymentDuration,
    canceled: false,
    address: null,
    zip: null,
    city: null,
    imei: null,
  }
}

export function cancelOrder(order) {
  order.canceled = true
  return { ...order }
}

export function setOrderAddress(order, address, zip, city) {
  order.address = address
  order.zip = zip
  order.city = city
  return { ...order }
}

export function setOrderIMEI(order, imei) {
  order.imei = imei
  return { ...order }
}

export function addOrderAddon(order, productId) {
  const products = order.products
  if (products.indexOf(productId) === -1) {
    products.push(productId)
  }
  return { ...order }
}

export function removeOrderAddon(order, productId) {
  const products = order.products
  const idx = products.indexOf(productId)
  if (idx > -1) {
    products.splice(idx, 1)
  }
  return { ...order }
}
